import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IInvestmentConclusion } from '@/modules/transaction/services/product-investment';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvestmentCompletedStep',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const investmentConclusion = inject(
  'investmentConclusion'
) as Ref<IInvestmentConclusion>;

function goToProducts() {
  router.push({
    name: 'productsCatalog',
    params: {
      type: route.params.type || 'fixed-income'
    }
  });
}

return { __sfc: true,route, router, investmentConclusion, goToProducts, ConclusionStep, ContentDisplay, Heading, ListDisplay, ButtonPrimary }
}

})